import { useCallback, useState } from 'react';
import { useHistory } from 'react-router';
import BasicButton from '../../components/BasicButton';
import BasicInput from '../../components/BasicInput';
import { login } from '../../misc/firebase';
import routes from '../../misc/routes';
import './LoginPage.scss';

const LoginPage = () => {
  const history = useHistory();

  const [ email, setEmail ] = useState('');
  const [ pass, setPass ] = useState('');
  const [ loggingIn, setLoggingIn ] = useState(false);
  const [ loginError, setLoginError ] = useState(false);

  const doLogin = useCallback(() => {
    setLoggingIn(true);
    login(email, pass).then(() => {
      history.push(routes.admin.path);
    }).catch((err) => {
      console.error(err);
      setLoginError(true);
      setLoggingIn(false);
    });
  }, [ email, pass, history ]);

  return (
    <div className="loginpage-container">
      <div>
        <h2>Bejelentkezés</h2>
        <BasicInput placeholder="E-mail cím"
          text={ email } onTextChanged={ setEmail }
          onSubmit={ doLogin } error={ loginError } />
        <BasicInput placeholder="Jelszó"
          text={ pass } onTextChanged={ setPass }
          onSubmit={ doLogin } error={ loginError } password />
        <BasicButton text="Tovább" type="primary"
          onClick={ doLogin } working={ loggingIn } />
      </div>
    </div>
  );
};

export default LoginPage;
